import React from 'react'

export const BookIcon = (color = '#030405', width = 24, height = 19.5) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 19.5"
      fill="none"
    >
      <g>
        <path
          d="M12 20C11.2 19.3667 10.3333 18.875 9.4 18.525C8.46667 18.175 7.5 18 6.5 18C5.8 18 5.1125 18.0917 4.4375 18.275C3.7625 18.4583 3.11667 18.7167 2.5 19.05C2.15 19.2333 1.8125 19.225 1.4875 19.025C1.1625 18.825 1 18.5333 1 18.15V6.1C1 5.91667 1.04583 5.74167 1.1375 5.575C1.22917 5.40833 1.36667 5.28333 1.55 5.2C2.31667 4.8 3.11667 4.5 3.95 4.3C4.78333 4.1 5.63333 4 6.5 4C7.46667 4 8.4125 4.125 9.3375 4.375C10.2625 4.625 11.15 5 12 5.5V17.6C12.85 17.0667 13.7417 16.6667 14.675 16.4C15.6083 16.1333 16.55 16 17.5 16C18.1 16 18.6875 16.05 19.2625 16.15C19.8375 16.25 20.4167 16.4 21 16.6V4.6C21.25 4.68333 21.4958 4.77083 21.7375 4.8625C21.9792 4.95417 22.2167 5.06667 22.45 5.2C22.6333 5.28333 22.7708 5.40833 22.8625 5.575C22.9542 5.74167 23 5.91667 23 6.1V18.15C23 18.5333 22.8375 18.825 22.5125 19.025C22.1875 19.225 21.85 19.2333 21.5 19.05C20.8833 18.7167 20.2375 18.4583 19.5625 18.275C18.8875 18.0917 18.2 18 17.5 18C16.5 18 15.5333 18.175 14.6 18.525C13.6667 18.875 12.8 19.3667 12 20ZM14 15V5.5L19 0.5V10.5L14 15ZM10 16.625V6.725C9.45 6.49167 8.87917 6.3125 8.2875 6.1875C7.69583 6.0625 7.1 6 6.5 6C5.88333 6 5.28333 6.05833 4.7 6.175C4.11667 6.29167 3.55 6.46667 3 6.7V16.625C3.58333 16.4083 4.1625 16.25 4.7375 16.15C5.3125 16.05 5.9 16 6.5 16C7.1 16 7.6875 16.05 8.2625 16.15C8.8375 16.25 9.41667 16.4083 10 16.625Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
